import script from "./ShapeElementOperate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeElementOperate.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeElementOperate.vue?vue&type=style&index=0&id=fd38df18&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd38df18"]])

export default __exports__